//* 계좌환불 '선지급 상환(SellerAdvance)' 프리셋 계좌 — DB에 박지 않고 프론트 상수로만 관리.
//* 계좌가 바뀌면 이 파일만 고쳐서 배포하면 끝.
//* 노출 조건: shop 이름에 keyword('마리')가 포함된 꽃집에서만 프리셋 버튼을 보여준다
//* (대표님이 직접 운영하는 꽃집 계열에서만 선지급 상환이 발생하기 때문).
export const SELLER_ADVANCE_ACCOUNT_PRESET = {
  label: '대표님 계좌 (선지급 상환)',
  bank: '농축협',
  accountNumber: '3560964179013',
  holderName: '신석균',
  shopNameKeyword: '마리',
};

export const isSellerAdvancePresetShop = (shopName?: string): boolean =>
  !!SELLER_ADVANCE_ACCOUNT_PRESET.accountNumber &&
  !!shopName &&
  shopName.includes(SELLER_ADVANCE_ACCOUNT_PRESET.shopNameKeyword);
